export { createInstanceFactory } from './createInstanceFactory.js';
export { unaccentAndLower } from './unaccentAndLower.js';
export { QUERY_STATE } from './constants.js';
export { useFetch } from './hooks/useFetch.js';
export { useLocalStorage } from './hooks/useLocalStorage.js';
export { useOnLine } from './hooks/useOnLine.js';
export { useThrottle } from './hooks/useThrottle.js';
export { deepFreeze } from './deepFreeze.js';
export { layerCanvasFilter } from './canvasFilter.js';
export { ensureArray } from './ensureArray.js';
export const identity = (value) => value;
export { createComparator } from './createComparator.js';
export { NestedMap } from './NestedMap.js';
export { removeFalsey } from './removeFalsey';
export { structuredClone } from './structuredClone.js';
export { getAbsoluteUrl } from './URL.js';
export { shallowCompare } from './compare.js';
export { deepLooselyEquals } from './deepLooselyEquals.js';
export { prepareFText, filterByFText } from './ftext.js';
export { CloneMap } from './CloneMap.js';
//# sourceMappingURL=index.js.map